<template>
    <JsonSchemaPhoneView v-if="form.schema.format === 'phone'" v-bind="propsWithListenerAttrs" />
    <JsonSchemaTextView v-else v-bind="propsWithListenerAttrs" />
</template>

<script lang="ts">
    import { Component } from '@evidentid/vue-property-decorator';

    import { JsonFormBase } from '@evidentid/json-schema/interfaces/JsonForm';
    import { JsonSchemaString } from '@evidentid/json-schema/interfaces/JsonSchema';

    import AbstractJsonSchemaView
        from '@/modules/entity-details/components/JsonSchemaView/elements/AbstractJsonSchemaView';

    import JsonSchemaPhoneView from './JsonSchemaPhoneView.vue';
    import JsonSchemaTextView from './JsonSchemaTextView.vue';

    @Component({
        components: { JsonSchemaPhoneView, JsonSchemaTextView },
        inheritAttrs: false,
    })
    export default class JsonSchemaStringView extends AbstractJsonSchemaView<JsonFormBase<JsonSchemaString>, string> {
    }
</script>
